import React, { ReactElement, ReactNode } from 'react';
import { cn } from 'utils';

import PageHeader from './PageHeader';

/**
 * Page component
 * @param {PageHeader} pageHeader - Page header component
 * @param {Node} children - Any node
 */

type PageProps = {
  pageHeader?: ReactElement<unknown>;
  children?: ReactNode;
} & React.HTMLAttributes<HTMLDivElement>;

function Page({ className, pageHeader, children, ...rest }: PageProps) {
  return (
    <div
      className={cn(
        'relative px-5 pb-3 overflow-x-hidden overflow-y-auto h-full w-full flex flex-col flex-1',
        className,
      )}
      {...rest}
    >
      {pageHeader && pageHeader}
      {children && children}
    </div>
  );
}

Page.Header = PageHeader;

export default Page;
